import React, { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import GenericConfirmModal from '../views/pages/census/components/ConfirmationModals/GenericConfirmModal'
import { getIsAi } from '../utils/sharedFeaturesFunctions'
import FEATURES from '../utils/featuresConstants'

export default function NoAiValidator() {
  const features = useSelector((state) => state.user.features)
  const [showModal, setShowModal] = useState(false)
  const isAIUrl = getIsAi()
  const hasClosed = localStorage.getItem('aiPopupClosed') === 'true'

  useEffect(() => {
    if (isAIUrl && !hasClosed && features && !features.includes(FEATURES.DesktopAI)) {
      setShowModal(true)
    }
  }, [isAIUrl, features, hasClosed])

  const onClose = () => {
    setShowModal(false)
    localStorage.setItem('aiPopupClosed', 'true')
  }

  return showModal ? (
    <GenericConfirmModal
      onClose={onClose}
      onConfirm={onClose}
      title={'AI Features Unavailable'}
      content={
        'The AI features you are attempting to use are currently unavailable for the selected practice. Please contact our Support Team at support@claimocity.com for assistance.'
      }
      showCancel={false}
    />
  ) : null
}
